import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {DynamicIdService} from 'shared/_services/dynamic.id.service';
import {ControlTemplate} from '../_interface/control-template.enum';
import {isControlRequired} from '../functions/check-if-control-required.fn';
import {FormFieldWarnings} from '../../../../journal/src/_interface/form-field-warnings.interface';

@Component({
	selector: 'form-number-input',
	templateUrl: './number-input.component.html',
	styleUrls: ['./number-input.component.scss']
})
export class NumberInputComponent implements OnInit {

	@Input()
	control: UntypedFormControl;

	@Input()
	placeholder: string;

	@Input()
	id: string = this.dynamicIdService.getId('number-input');

	@Input()
	label: string;

	@Input()
	template: ControlTemplate = ControlTemplate.inline;

	@Input()
	min: number;

	@Input()
	max: number;

	@Input()
	step = 1;

	@Input() set setWarnings(warnings: FormFieldWarnings) {
		this.warnings = warnings;
	}

	ControlTemplate = ControlTemplate;
	isControlRequired: boolean;
	warnings: FormFieldWarnings;

	constructor(private dynamicIdService: DynamicIdService) {
	}

	ngOnInit(): void {
		if (!this.control) throw new Error('Control is required');
		this.isControlRequired = isControlRequired(this.control);
	}

	handleInput(target: any) {
		if (target.value || target.value === 0) {
			if (target.value > this.max) target.value = this.max;
			if (target.value < this.min) target.value = this.min;
		}
		this.control.setValue(target.value);
		this.control.markAsTouched();
	}
}
